import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-video-24-px_66bc0dae45b14084912e75cd021e9d9c",
  "use": "add-video-24-px_66bc0dae45b14084912e75cd021e9d9c-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"add-video-24-px_66bc0dae45b14084912e75cd021e9d9c\">\n    <path fill=\"#888A97\" fill-rule=\"evenodd\" d=\"M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm5.794 3.696A.5.5 0 0 0 10 9.1v5.8a.5.5 0 0 0 .794.404l3.98-2.9a.5.5 0 0 0 0-.808l-3.98-2.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol